import { Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "../layout/Layout";
import { HomePage } from "../pages/HomePage";
import { ClientsPage } from "../pages/ClientsPage";
import { ClientDetailPage } from "../pages/ClientDetailPage";
import { SessionDetailPage } from "../pages/SessionDetailPage";
import { MethodologyPage } from "../pages/MethodologyPage";
import { ContentPage } from "../pages/ContentPage";
import { CoachPage } from "../pages/CoachPage";
import { CouplesCoachingPage } from "../pages/CouplesCoachingPage";
import { TheoryAlbumPage } from "../pages/TheoryAlbumPage";
import { GuidesPage } from "../pages/GuidesPage";
import { ResearchPage } from "../pages/ResearchPage";
import { AutomationsPage } from "../pages/AutomationsPage";
import { allContentRoutes } from "../pages/methodology-registry";

/**
 * Top-level app. AuthKitProvider (WorkOS) gates this whole tree via
 * AuthGate in App.tsx, so every route in here assumes an authenticated user.
 *
 * Sidebar holds the working pages (Home, Clients, Session, Coach, Couples,
 * Content, Automations) plus library landing pages (Methodology, Theory
 * Album, Guides, Research). Individual content pages (methodology cards,
 * theory album chapters, guides) are auto-registered via
 * `allContentRoutes`, reachable from the corresponding library page.
 */
export const CRM = () => (
  <Layout>
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/clients" element={<ClientsPage />} />
      <Route path="/clients/:id" element={<ClientDetailPage />} />
      <Route
        path="/clients/:clientId/sessions/:sessionId"
        element={<SessionDetailPage />}
      />
      <Route path="/coach" element={<CoachPage />} />
      <Route path="/couples-coaching" element={<CouplesCoachingPage />} />
      <Route path="/content" element={<ContentPage />} />
      <Route path="/automations" element={<AutomationsPage />} />
      <Route path="/methodology" element={<MethodologyPage />} />
      <Route path="/theory-album" element={<TheoryAlbumPage />} />
      <Route path="/guides" element={<GuidesPage />} />
      <Route path="/research" element={<ResearchPage />} />

      {/* Auto-registered content routes: methodology cards, theory album,
          guides. Each imported page sets its own `.path` metadata. */}
      {allContentRoutes.map(({ path, component: Component }) => (
        <Route key={path} path={path} element={<Component />} />
      ))}

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </Layout>
);
